import { render, staticRenderFns } from "./InputMoneyComponent2.vue?vue&type=template&id=5b7f6ce5&"
import script from "./InputMoneyComponent2.vue?vue&type=script&lang=js&"
export * from "./InputMoneyComponent2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports